<template>
    <common-page flex-column card-content>
        <query-view config-code="ppe_inventory" enable-edit
                    with-custom-actions-head-of-row>
            <template #headOfRow="{row}">
                <mini-button @btnClick="gotoDocumentList(row)">
                    <i class="fa-solid fa-right-long"></i>
                </mini-button>
            </template>
        </query-view>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default {
    name: "PpeInventoryQueryView",
    components: {MiniButton, QueryView, CommonPage},
    methods: {
        gotoDocumentList(row) {
            this.$router.push({
                name: 'sithMomPjDocument',
                query: {
                    pjIdFilter: row.id
                }
            })
        },
    }
}
</script>

<style scoped>

</style>
